import axios from './request'

const check_version_from_server = async (now) => {
    let url = '/static/version.json';
    localStorage.setItem('version_update_time', now)
    let res = await axios.get(url)
    if (res.status === 200) {
            let shared_atomic_version = res.data.version;
            let local_shared_atomic_version = localStorage.getItem('shared_atomic_version');
            if (local_shared_atomic_version == null || local_shared_atomic_version != shared_atomic_version) {
                localStorage.setItem('shared_atomic_version', shared_atomic_version);
                window.location.reload(true);// 强制从服务器获取最新内容
            }
    }
}

const isNewVersion = async () => {
    let version_update_time = localStorage.getItem('version_update_time')
    let now = new Date().getTime()
    if (version_update_time != null ) {
        if (now - version_update_time >= 24*3600*1000) {
            await check_version_from_server(now);
        }
    }
    else {
        await check_version_from_server(now);
    }
}

export default {
    isNewVersion
}